module.exports = __webpack_public_path__ + "assets/media/morning.ae007fb2.mp3";